<template>
  <section
    class="component-f80cbcd0"
    resmed-component-name="survey_50/50_icon-line_text_image_YNcta"
  >
    <div
      class="component"
      v-bind:style="{
        'background-image': `url(${acf.layout.background})`,
      }"
    >
      <div class="embed-responsive embed-responsive-4by3 d-md-none">
        <!--  -->
      </div>

      <div class="container px-xs-sm-2">
        <div class="row align-items-center content">
          <div class="col-md-6 col-xl-5 offset-xl-1">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
            ></eyebrow-icon>
            <h2>
              <span v-html="acf.headline"></span>
            </h2>
            <a
              v-for="item in acf.cta"
              v-bind:href="item.cta.href"
              v-bind:target="item.cta.target"
              class="btn icon cta-pill hallow-white right-arrow"
              >{{ item.cta.text }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-f80cbcd0", // survey_50/50_icon-line_text_image_YNcta
  props: ["acf"],
  data() {
    return {
      active: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-f80cbcd0 {
  background-image: url(#{$assets}/images/ventilation-quiz-bg@2x.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.component {
  overflow: hidden;

  background-color: transparent;
  background-position: right 2rem;
  background-repeat: no-repeat;
  background-size: 100vw;

  @media (min-width: 768px) {
    background-position: calc(100% + 5rem) center;
    background-size: 490px;
  }

  @media (min-width: 880px) {
    background-size: 530px;
  }

  @media (min-width: 992px) {
    background-size: 590px;
  }

  @media (min-width: 1100px) {
    background-size: 660px;
  }

  @media (min-width: 1200px) {
    background-size: 760px;
    background-position: calc(100% + 3rem) 3rem;
  }

  h2 {
    margin-bottom: 1.25rem;
    position: relative;
    color: $cc-resmed-white;
    margin-bottom: 2rem;

    @extend %eyebrow-left;
    &:before {
      background-color: $cc-resmed-white;
    }
  }

  .content {
    @media (max-width: 991px) {
      padding: 5rem 0;
    }

    @media (min-width: 768px) {
      min-height: 500px;
    }

    @media (min-width: 992px) {
      min-height: 500px;
    }

    @media (min-width: 1100px) {
      min-height: 580px;
    }
  }

  .btn {
    margin-right: 2rem;
    padding-left: 1.825rem;
  }
}
</style>